import anime from "animejs/lib/anime.es.js";

import loverCatUrl from "../assets/img/lover-cat.gif";
import runningCatUrl from "../assets/img/running-cat.gif";
// import halfCatUrl from "../assets/img/half-cat.gif";
import madCatUrl from "../assets/img/mad-cat.gif";

import daweiCatUrlRtoL from "../assets/img/daweiCatRtoL.gif";
import daweiCatUrlLtoR from "../assets/img/daweiCatLtoR.gif";

const cats = [daweiCatUrlRtoL, daweiCatUrlLtoR];

const options = [
  {
    from: "(.*)",
    to: "(.*)",
    in: next => {
      // console.log("in");

      const opacityAnim = anime({
        targets: "#swup",
        opacity: [0, 1],
        duration: 2000,
        autoplay: true,
        update: function(anim) {
          anim.progress > 60 && next();
        }
      });

      const h1Anime = anime({
        targets: ".entry-header h1, .single-post .entry-header .page-title, .archive h1.page-title ",
        duration: 400,
        opacity: [0, 1],
        translateX: [-100, 0],

        easing: "easeInQuad",
        autoplay: true
      });

      // const breadcrumbsAnime = anime({
      //   targets: ".breadcrumbs",
      //   duration: 400,
      //   opacity: [0, 1],
      //   translateX: [-20, 0],

      //   easing: "easeInQuad",
      //   autoplay: true
      // });

      // const pageThumbnail = anime({
      //   targets: "body.page .entry-page .entry-thumbnail, .single-post .entry-thumbnail",
      //   duration: 400,
      //   opacity: [0, 1],
      //   translateY: [100, 0],

      //   easing: "easeInQuad",
      //   autoplay: true
      // });

      const loopItems = anime({
        targets: "#loop article",
        duration: 400,
        opacity: [0, 1],
        translateY: [150, 0],
        delay: anime.stagger(150),
        easing: "easeInQuad",
        autoplay: true
      });

      const arrowLinks = anime({
        targets: [".content_links li", ".column-links li"],
        duration: 300,
        opacity: [0, 1],
        translateX: [-50, 0],
        delay: anime.stagger(50),
        easing: "easeInQuad",
        autoplay: true
      });
    },
    out: next => {
      // console.log("out");

      const catUrl = cats[Math.floor(Math.random() * cats.length)];

      //addCat(trollCat1Url);
      const catElem = getCat(catUrl);

      const clientWidth = document.documentElement.clientWidth;
      const duration = (clientWidth + 400) * (2 + Math.random()/4);

      let paramsByAnim = {};
      if (catUrl === daweiCatUrlRtoL) {
        paramsByAnim = {
          translateX: [200, -(clientWidth + 200)],
          complete: function(anim) {
            catElem.style.transform = "translateX(200px)";
          }
        };
      }

      if (catUrl === daweiCatUrlLtoR) {
        paramsByAnim = {
          translateX: [-200, clientWidth + 200],
          complete: function(anim) {
            catElem.style.transform = "translateX(-200px)";
          }
        };
      }

      if (Math.random() > 0.5) {
        const catAnim = anime({
          targets: catElem,
          duration: duration,
          easing: "linear",
          autoplay: true,
          ...paramsByAnim
        });

        catAnim.finished.then(() => next());
      } else {
        catElem.style.display = "none";
      }

      const opacityAnim = anime({
        targets: "#swup",
        opacity: [1, 0],
        duration: 400,
        autoplay: true,
        easing: "easeInOutQuad",
        update: function(anim) {
          anim.progress > 60 && next();
        }
      });

      const logoAnime = anime({
        targets: ".suki-logo-image svg",
        keyframes: [
          {
            scale: 1,
            filter: "blur(0px)"
          },
          {
            filter: "blur(1px)"
          },
          {
            filter: "blur(2px)"
          },
          {
            filter: "blur(1px)"
          },
          {
            scale: 1,
            filter: "blur(0px)"
          }
        ],
        easing: "linear",
        duration: 1000,
        autoplay: true
      });

      if (Math.random() > 0.5) {
        const logoAnimeLetters = anime({
          targets: ".suki-logo-image svg path",
          opacity: [1, 0.7, 1],
          delay: anime.stagger(150),
          easing: "linear",
          duration: 1000,
          autoplay: true
        });
      }
    }
  }
];

const getCat = url => {
  let cat = document.getElementById("cat");
  if (!cat) {
    cat = document.createElement("img");
    cat.id = "cat";
    cat.className = "animated-cat";

    cat.style.position = "fixed";
    cat.style.bottom = "20px";
    cat.style.bottom = "0px";
    cat.style.zIndex = 999;
    // cat.style.height = "358px";

    daweiCatUrlRtoL;

    document.body.appendChild(cat);
  }

  const catWidth = Math.ceil(Math.random() * 30) + 120;
  // const catOpacity = Math.random() * 0.15;
  // const catDecay = catWidth + Math.ceil(Math.random() * 500) - 100;
  // const catDecayH = Math.ceil(Math.random() * 40) - 30;

  cat.style.display = "block";

  if (url === daweiCatUrlRtoL) {
    cat.style.right = 0;
    cat.style.left = "auto";
    cat.style.transform = "translateX(200px)";
    cat.style.filter = "contrast(200%) grayscale(1);";
    // cat.style.filter = `drop-shadow(${catDecay}px ${catDecayH}px 2px rgba(0,0,0,${catOpacity}) )`;
  }

  if (url === daweiCatUrlLtoR) {
    cat.style.right = "auto";
    cat.style.left = 0;
    cat.style.transform = "translateX(-200px)";
    cat.style.filter = "contrast(200%) grayscale(1);";
    // cat.style.filter = `drop-shadow(-${catDecay}px ${catDecayH}px 2px rgba(0,0,0,${catOpacity}) )`;
  }

  cat.style.width = catWidth + "px";

  cat.src = url;

  return cat;
};

export default options;
